import Glide from '@glidejs/glide'
import { openShareList } from '../accessibility/chapter'
import { initSiblingsSlider } from '../siblings-slider'
import { initSimpleSlider } from '../simple-slider'
import { isChapterWatched } from '../video/helpers'

const imageSliderFullScreen = document.querySelector('.media-slider')
const imageDescriptionText = document.querySelector("#image-description .description-text")

function initImageSlider () {
    let glide,
        glideHTMLElement = document.querySelector('#image-slider')

    if (glideHTMLElement) {
        glide = new Glide(`#image-slider`, { type: 'carousel', keyboard: false }).mount()
        glideHTMLElement.addEventListener('keyup', (e) => {
            if (e.keyCode == 39) glide.go('>')
            if (e.keyCode == 37) glide.go('<')
          })
        glide.on('run.after', updateDiscription)
    }
    let onFullscreenchange = () => {
        if (document.fullscreenElement === null || document.webkitCurrentFullScreenElement === null || document.mozFullScreenElement === null) {
            imageSliderFullScreen.classList.remove('fullscreen-mode')
        }
        if(glide){
            glide.update()
        }
    }

    if(imageSliderFullScreen.requestFullscreen){
        document.addEventListener('fullscreenchange', onFullscreenchange, true)
    } else if (imageSliderFullScreen.mozRequestFullScreen) {
        document.addEventListener('mozfullscreenchange', onFullscreenchange, true)
    } else if (imageSliderFullScreen.webkitRequestFullscreen) {
        document.addEventListener('webkitfullscreenchange', onFullscreenchange, true)
    } else {
        document.querySelectorAll('.fullscreen-mode-button').forEach(element => element.style.display = 'none')
    }

    initHelpers()
}
function updateDiscription() {
    let imageDesc = document.querySelector(".glide__slide--active .img-description").innerHTML
    imageDescriptionText.innerHTML = imageDesc;
}
function fullScreenImageSlider () {
    if (document.fullscreenElement || document.webkitCurrentFullScreenElement || document.mozFullScreenElement) {
        imageSliderFullScreen.classList.remove('fullscreen-mode')
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
            document.mozExitFullScreen()
        } else if (document.webkitCancelFullScreen) {
            document.webkitExitFullscreen()
        }
    } else {
        imageSliderFullScreen.classList.add('fullscreen-mode')
        if (imageSliderFullScreen.requestFullscreen) {
            imageSliderFullScreen.requestFullscreen()
        } else if (imageSliderFullScreen.mozRequestFullScreen) {
            imageSliderFullScreen.mozRequestFullScreen()
        } else if (imageSliderFullScreen.webkitRequestFullscreen) {
            imageSliderFullScreen.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
        }
    }
}
function initHelpers () {
    window.helpers.openShareList = openShareList
    window.helpers.fullScreenImageSlider = fullScreenImageSlider
}

isChapterWatched()
initImageSlider()
initSiblingsSlider()
initSimpleSlider()